module.exports = {"360921100":"冯川镇","360921101":"赤岸镇","360921102":"赤田镇","360921103":"宋埠镇","360921104":"干洲镇","360921105":"澡下镇","360921106":"会埠镇","360921107":"罗市镇","360921108":"上富镇","360921109":"甘坊镇","360921200":"仰山乡","360921201":"澡溪乡","360921202":"柳溪乡","360921400":"奉新县工业园区","360921500":"石溪","360921501":"百丈山名胜风景区","360921502":"干洲垦殖场","360921503":"东风垦殖场","360921504":"农牧渔良种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360921.json
// module id = 1218
// module chunks = 0